import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../../assets/img/icons/up-down-aroow.svg'
import _imports_1 from '../../../assets/img/icons/eye.svg'
import _imports_2 from '../../../assets/img/icons/edit.svg'
import _imports_3 from '../../../assets/img/icons/close.svg'
import _imports_4 from '../../../assets/img/icons/left-arrow-purple.svg'
import _imports_5 from '../../../assets/img/icons/right-arrow-purple.svg'


const _hoisted_1 = { class: "card border-0 shadow-none rounded-1 mb-25" }
const _hoisted_2 = { class: "card-body p-xl-40" }
const _hoisted_3 = { class: "table-responsive style-three" }
const _hoisted_4 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_5 = { class: "shadow-none fw-normal text-black title ps-0" }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = { class: "text-optional fs-14 ms-2" }
const _hoisted_8 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_9 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_10 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_11 = { class: "shadow-none lh-1 text-end pe-0" }
const _hoisted_12 = { class: "button-group d-flex flex-wrap align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("table", _hoisted_4, [
            _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-title fw-normal fs-14 pt-0 ps-0"
                }, [
                  _createElementVNode("div", { class: "form-check checkbox" }, [
                    _createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "test_1"
                    }),
                    _createElementVNode("label", {
                      class: "form-check-label",
                      for: "test_1"
                    }, [
                      _createTextVNode(" DATE "),
                      _createElementVNode("img", {
                        class: "ms-2",
                        src: _imports_0,
                        alt: "Image"
                      })
                    ])
                  ])
                ]),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-title fw-normal fs-14 pt-0"
                }, [
                  _createTextVNode(" REFERENCE "),
                  _createElementVNode("img", {
                    class: "ms-2",
                    src: _imports_0,
                    alt: "Image"
                  })
                ]),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-title fw-normal fs-14 pt-0"
                }, [
                  _createTextVNode(" WAREHOUSE "),
                  _createElementVNode("img", {
                    class: "ms-2",
                    src: _imports_0,
                    alt: "Image"
                  })
                ]),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-title fw-normal fs-14 pt-0"
                }, [
                  _createTextVNode(" TOTAL PRODUCTS "),
                  _createElementVNode("img", {
                    class: "ms-2",
                    src: _imports_0,
                    alt: "Image"
                  })
                ]),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-title fw-normal fs-14 pt-0 pe-0"
                }, " ACTION ")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adjustments, (adjustment) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: adjustment.id
                }, [
                  _createElementVNode("td", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "form-check checkbox style-three" }, [
                        _createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          id: "test_2"
                        }),
                        _createElementVNode("label", {
                          class: "form-check-label text-optional",
                          for: "test_2"
                        })
                      ], -1)),
                      _createElementVNode("span", _hoisted_7, _toDisplayString(adjustment.date), 1)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_8, _toDisplayString(adjustment.reference), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(adjustment.warehouse), 1),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(adjustment.totalProducts), 1),
                  _createElementVNode("td", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _cache[2] || (_cache[2] = _createElementVNode("a", {
                        href: "javascript:void(0)",
                        title: "View",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#detailsModal"
                      }, [
                        _createElementVNode("img", {
                          src: _imports_1,
                          alt: "Image"
                        })
                      ], -1)),
                      _createVNode(_component_router_link, {
                        to: "/edit-adjustment",
                        title: "Edit"
                      }, {
                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                          _createElementVNode("img", {
                            src: _imports_2,
                            alt: "Image"
                          }, null, -1)
                        ])),
                        _: 1,
                        __: [1]
                      }),
                      _cache[3] || (_cache[3] = _createElementVNode("a", {
                        class: "delete-btn",
                        "data-bs-toggle": "offcanvas",
                        href: "#deletePopup",
                        role: "button",
                        "aria-controls": "deletePopup"
                      }, [
                        _createElementVNode("img", {
                          src: _imports_3,
                          alt: "Image"
                        })
                      ], -1))
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"row pb-45 align-items-center\"><div class=\"col-sm-6\"><div class=\"d-flex flex-wrap align-items-center justify-content-center justify-content-sm-start page-unit\"><span class=\"fs-13\">Showing product per page</span><select class=\"text-title border-0 fs-14 bg-transparent\"><option value=\"0\">10</option><option value=\"1\">20</option><option value=\"2\">30</option></select></div></div><div class=\"col-sm-6 text-sm-end text-center\"><ul class=\"page-nav list-style\"><li><a href=\"#\"><img src=\"" + _imports_4 + "\" alt=\"Image\"></a></li><li><a href=\"#\" class=\"active\">1</a></li><li><a href=\"#\">2</a></li><li><a href=\"#\">3</a></li><li><a href=\"#\"><img src=\"" + _imports_5 + "\" alt=\"Image\"></a></li></ul></div></div>", 1))
  ], 64))
}